import { render, staticRenderFns } from "./RepresentativeInput.vue?vue&type=template&id=69961d15&"
import script from "./RepresentativeInput.vue?vue&type=script&lang=ts&"
export * from "./RepresentativeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports